/** @jsxImportSource @emotion/react */
import { useLocation, useNavigate } from 'react-router-dom';
import * as s from './style';
import React from 'react';
import { useRecoilState } from 'recoil';
import { logTokenAtom } from '../../../atoms/log/LogTokenStore';
import { createLog } from '../../../atoms/log/LogFunction';
import CommonButton from '../../atoms/button/CommonButton';
import { css } from '@emotion/react';
import { TrendingUp, People, Psychology, AccountBalance, LocationOn } from '@mui/icons-material';
import GalleryMenuIcon from './menu_item/GalleryMenuIcon';

const GalleryLinkMenu = () => {
    const [logTokenState, setLogTokenState] = useRecoilState(logTokenAtom);
    const location = useLocation();
    const navigate = useNavigate();

    const onClickGalleryLinkIcon = async (categoryCd) => {
        navigate('/gallery', { state: { categoryCd: categoryCd } });

        const logOption = {
            page: location.pathname,
            eventName: 'move_to_gallery',
            eventValue: categoryCd,
            level: 1,
            parentEvent: null,
            sessionToken: logTokenState,
        };

        const newToken = await createLog(logOption);
        setLogTokenState(newToken);
    };

    return (
        <div css={s.mainContainer}>
            <header css={s.header}>▼ Map GALLERY</header>
            <GalleryMenuIcon
                size={150}
                coord={[195, 220]}
                backgroundColor={'royalblue'}
                padding={40}
                src="images/icon-01.png"
                hoverText={'인구특성'}
                onClick={() => onClickGalleryLinkIcon('106')}
            />
            <GalleryMenuIcon
                size={120}
                coord={[50, 250]}
                backgroundColor={'skyblue'}
                padding={30}
                src="images/icon-02.png"
                hoverText={'사회/복지'}
                onClick={() => onClickGalleryLinkIcon('404')}
            />
            <GalleryMenuIcon
                size={150}
                coord={[90, 80]}
                backgroundColor={'yellowgreen'}
                padding={35}
                src="images/icon-03.png"
                hoverText={'경제구조'}
                onClick={() => onClickGalleryLinkIcon('202')}
            />
            <GalleryMenuIcon
                size={100}
                coord={[175, 380]}
                backgroundColor={'lightgray'}
                padding={20}
                src="images/icon-04.png"
                hoverText={'재정/세금'}
                onClick={() => onClickGalleryLinkIcon('302')}
            />
            <GalleryMenuIcon
                size={60}
                coord={[0, 70]}
                backgroundColor={'dimgray'}
                padding={7}
                src="images/icon-05.png"
            />
            <GalleryMenuIcon
                size={80}
                coord={[220, 20]}
                backgroundColor={'royalblue'}
                padding={20}
                src="images/icon-06.png"
            />
            <GalleryMenuIcon
                size={80}
                coord={[290, 115]}
                backgroundColor={'orange'}
                padding={20}
                src="images/icon-07.png"
            />
            <GalleryMenuIcon
                size={50}
                coord={[100, 400]}
                backgroundColor={'royalblue'}
                padding={10}
                src="images/icon-08.png"
            />

            <GalleryMenuIcon size={20} coord={[0, 420]} backgroundColor={'gray'} />
            <GalleryMenuIcon size={30} coord={[15, 340]} backgroundColor={'pink'} />
            <GalleryMenuIcon size={40} coord={[40, 205]} backgroundColor={'dimgray'} />
            <GalleryMenuIcon size={30} coord={[50, 380]} backgroundColor={'yellowgreen'} />
            <GalleryMenuIcon size={30} coord={[120, 25]} backgroundColor={'orange'} />
            <GalleryMenuIcon size={30} coord={[330, 0]} backgroundColor={'gray'} />
            <GalleryMenuIcon size={50} coord={[345, 335]} backgroundColor={'skyblue'} />
            {/* CommonButton 사용한 개선안은 나중에 사용할 수 있기 때문에 보관함

            <CommonButton
                variant="image"
                size="large"
                layout="vertical"
                onClick={() => window.open('https://sodamap.co.kr:8449/', '_blank')}
                startIcon={<LocationOn />}
                customStyles={css`
                    position: absolute !important;
                    top: 250px;
                    left: 50px;
                    background: linear-gradient(135deg, #ff6b6b 0%, #ee5a24 100%);
                    color: white;
                    border-radius: 50%;
                    width: 150px;
                    height: 150px;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    text-align: center;
                    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
                    transition: all 0.3s ease;
                    position: relative;
                    overflow: hidden;
                    z-index: 100;

                    &:hover {
                        transform: scale(1.1) translateY(-5px);
                        box-shadow: 0 8px 25px rgba(0, 0, 0, 0.3);
                    }

                    &:before {
                        content: '';
                        position: absolute;
                        top: 0;
                        left: -100%;
                        width: 100%;
                        height: 100%;
                        background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
                        transition: left 0.5s;
                    }

                    &:hover:before {
                        left: 100%;
                    }

                    svg {
                        font-size: 2rem;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                    }

                    span {
                        font-size: 12px;
                        font-weight: 600;
                        text-align: center;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                    }
                `}
            >
                <span>주소찾기</span>
            </CommonButton>
            <CommonButton
                variant="image"
                size="large"
                layout="vertical"
                onClick={() => onClickGalleryLinkIcon('106')}
                startIcon={<Psychology />}
                customStyles={css`
                    position: absolute !important;
                    top: 195px;
                    left: 220px;
                    background: linear-gradient(135deg, #4169e1 0%, #1e90ff 100%);
                    color: white;
                    border-radius: 50%;
                    width: 150px;
                    height: 150px;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    text-align: center;
                    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
                    transition: all 0.3s ease;
                    position: relative;
                    overflow: hidden;

                    &:hover {
                        transform: scale(1.1) translateY(-5px);
                        box-shadow: 0 8px 25px rgba(0, 0, 0, 0.3);
                    }

                    &:before {
                        content: '';
                        position: absolute;
                        top: 0;
                        left: -100%;
                        width: 100%;
                        height: 100%;
                        background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
                        transition: left 0.5s;
                    }

                    &:hover:before {
                        left: 100%;
                    }

                    svg {
                        font-size: 2.5rem;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                    }

                    span {
                        font-size: 14px;
                        font-weight: 600;
                        text-align: center;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                    }
                `}
            >
                <span>인구특성</span>
            </CommonButton>

            <CommonButton
                variant="image"
                size="large"
                layout="vertical"
                onClick={() => onClickGalleryLinkIcon('404')}
                startIcon={<People />}
                customStyles={css`
                    position: absolute !important;
                    top: 50px;
                    left: 250px;
                    background: linear-gradient(135deg, #87ceeb 0%, #00bfff 100%);
                    color: white;
                    border-radius: 50%;
                    width: 120px;
                    height: 120px;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    text-align: center;
                    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
                    transition: all 0.3s ease;
                    position: relative;
                    overflow: hidden;

                    &:hover {
                        transform: scale(1.1) translateY(-5px);
                        box-shadow: 0 8px 25px rgba(0, 0, 0, 0.3);
                    }

                    &:before {
                        content: '';
                        position: absolute;
                        top: 0;
                        left: -100%;
                        width: 100%;
                        height: 100%;
                        background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
                        transition: left 0.5s;
                    }

                    &:hover:before {
                        left: 100%;
                    }

                    svg {
                        font-size: 2rem;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                    }

                    span {
                        font-size: 12px;
                        font-weight: 600;
                        text-align: center;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                    }
                `}
            >
                <span>사회/복지</span>
            </CommonButton>

            <CommonButton
                variant="image"
                size="large"
                layout="vertical"
                onClick={() => onClickGalleryLinkIcon('202')}
                startIcon={<TrendingUp />}
                customStyles={css`
                    position: absolute !important;
                    top: 90px;
                    left: 80px;
                    background: linear-gradient(135deg, #9acd32 0%, #6b8e23 100%);
                    color: white;
                    border-radius: 50%;
                    width: 150px;
                    height: 150px;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    text-align: center;
                    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
                    transition: all 0.3s ease;
                    position: relative;
                    overflow: hidden;

                    &:hover {
                        transform: scale(1.1) translateY(-5px);
                        box-shadow: 0 8px 25px rgba(0, 0, 0, 0.3);
                    }

                    &:before {
                        content: '';
                        position: absolute;
                        top: 0;
                        left: -100%;
                        width: 100%;
                        height: 100%;
                        background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
                        transition: left 0.5s;
                    }

                    &:hover:before {
                        left: 100%;
                    }

                    svg {
                        font-size: 2.5rem;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                    }

                    span {
                        font-size: 14px;
                        font-weight: 600;
                        text-align: center;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                    }
                `}
            >
                <span>경제구조</span>
            </CommonButton>

            <CommonButton
                variant="image"
                size="large"
                layout="vertical"
                onClick={() => onClickGalleryLinkIcon('302')}
                startIcon={<AccountBalance />}
                customStyles={css`
                    position: absolute !important;
                    top: 175px;
                    left: 380px;
                    background: linear-gradient(135deg, #d3d3d3 0%, #a9a9a9 100%);
                    color: white;
                    border-radius: 50%;
                    width: 100px;
                    height: 100px;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    text-align: center;
                    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
                    transition: all 0.3s ease;
                    position: relative;
                    overflow: hidden;

                    &:hover {
                        transform: scale(1.1) translateY(-5px);
                        box-shadow: 0 8px 25px rgba(0, 0, 0, 0.3);
                    }

                    &:before {
                        content: '';
                        position: absolute;
                        top: 0;
                        left: -100%;
                        width: 100%;
                        height: 100%;
                        background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
                        transition: left 0.5s;
                    }

                    &:hover:before {
                        left: 100%;
                    }

                    svg {
                        font-size: 1.8rem;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                    }

                    span {
                        font-size: 11px;
                        font-weight: 600;
                        text-align: center;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                    }
                `}
            >
                <span>재정/세금</span>
            </CommonButton>

            <div
                css={css`
                    position: absolute;
                    top: 0px;
                    left: 70px;
                    width: 60px;
                    height: 60px;
                    background: dimgray;
                    border-radius: 50%;
                    opacity: 0.6;
                `}
            />

            <div
                css={css`
                    position: absolute;
                    top: 220px;
                    left: 20px;
                    width: 80px;
                    height: 80px;
                    background: royalblue;
                    border-radius: 50%;
                    opacity: 0.6;
                `}
            />

            <div
                css={css`
                    position: absolute;
                    top: 290px;
                    left: 115px;
                    width: 80px;
                    height: 80px;
                    background: orange;
                    border-radius: 50%;
                    opacity: 0.6;
                `}
            />

            <div
                css={css`
                    position: absolute;
                    top: 100px;
                    left: 400px;
                    width: 50px;
                    height: 50px;
                    background: royalblue;
                    border-radius: 50%;
                    opacity: 0.6;
                `}
            />

            <div
                css={css`
                    position: absolute;
                    top: 0px;
                    left: 420px;
                    width: 20px;
                    height: 20px;
                    background: gray;
                    border-radius: 50%;
                    opacity: 0.6;
                `}
            />

            <div
                css={css`
                    position: absolute;
                    top: 15px;
                    left: 340px;
                    width: 30px;
                    height: 30px;
                    background: pink;
                    border-radius: 50%;
                    opacity: 0.6;
                `}
            />

            <div
                css={css`
                    position: absolute;
                    top: 40px;
                    left: 205px;
                    width: 40px;
                    height: 40px;
                    background: dimgray;
                    border-radius: 50%;
                    opacity: 0.6;
                `}
            />

            <div
                css={css`
                    position: absolute;
                    top: 50px;
                    left: 380px;
                    width: 30px;
                    height: 30px;
                    background: yellowgreen;
                    border-radius: 50%;
                    opacity: 0.6;
                `}
            />

            <div
                css={css`
                    position: absolute;
                    top: 120px;
                    left: 25px;
                    width: 30px;
                    height: 30px;
                    background: orange;
                    border-radius: 50%;
                    opacity: 0.6;
                `}
            />

            <div
                css={css`
                    position: absolute;
                    top: 330px;
                    left: 0px;
                    width: 30px;
                    height: 30px;
                    background: gray;
                    border-radius: 50%;
                    opacity: 0.6;
                `}
            />

            <div
                css={css`
                    position: absolute;
                    top: 345px;
                    left: 335px;
                    width: 50px;
                    height: 50px;
                    background: skyblue;
                    border-radius: 50%;
                    opacity: 0.6;
                `}
            />

             */}
        </div>
    );
};

export default GalleryLinkMenu;
